// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    url: "https://m.media-amazon.com/images/M/MV5BZmMzNTU3MjMtN2MxZS00NjZjLTkxMDQtNGRkMTllNWZiZDUxXkEyXkFqcGdeQXJoYW5uYWg@._V1_QL40_QL75_UX1000_CR0,0,1000,563_.jpg",
    rating: "5:29",
    desc: 'Watch Our "stranger Things" season 3 Recao',
  },
  {
    url: "https://m.media-amazon.com/images/M/MV5BY2QzZWJmYjEtODBiYS00M2JhLTg1OWMtY2I2YjY3YWU3MDAzXkEyXkFqcGdeQWFsZWxvZw@@._V1_QL75_UX760_CR0,0,760,428_.jpg",
    rating: "3:24",
    desc: "The 'Top Gun: Maverick' Cast Describe Taking to the Skies",
  },
  {
    url: "https://m.media-amazon.com/images/M/MV5BOWEwODkwNzUtN2I1YS00ZDNmLThhYzMtOWU4OWYzYjRmNzBkXkEyXkFqcGdeQWpoZWZ0bGVy._V1_QL75_UX760_CR0,0,760,428_.jpg",
    rating: "2:30",
    desc: "Joe Alwyn and Alison Oliver Ask Each Other Anything",
  },
];
